import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
  Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import $ from 'jquery';
import AcademicPage from '../../views/AcademicPage/';
import Sanitize from '../../Sanitize';
const GLOBAL = require('../../Globals');

class EnterMark extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			acyear : '',
			cls : '',
			section : '',
			examname : '',
			subject : '',
			_message : '',
			alertClass :'',
			_redirect : false,
			posts: [],
			accyear : [],
			exams : [],
			subj : [],
			modal : false,
			modal1 : false,
			timetab : [],
			data : [],
			marks : [],
			markdata : [],
			regno : '',
			mark : '',
			remarks : '',
			sections : [],
			sec : [],
			allocateSubject : [],
			allocateClass : [],
		}
		this.onChange = this.onChange.bind(this);
		this.onSecChange = this.onSecChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.toggle = this.toggle.bind(this);
		this.toggle1 = this.toggle1.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleRemarkChange = this.handleRemarkChange.bind(this);
		this.onMarkUpdate = this.onMarkUpdate.bind(this);
		this.onReMarkUpdate = this.onReMarkUpdate.bind(this);
		this.onClassChange = this.onClassChange.bind(this);
		this.onSubChange = this.onSubChange.bind(this);
		this.onMarkChange = this.onMarkChange.bind(this);
		this.onExamChange = this.onExamChange.bind(this);
		this.onChangeRemark = this.onChangeRemark.bind(this);
	}
	
	toggle(){
		this.setState({
		  modal: !this.state.modal
		});
	}
	
	toggle1(){
		this.setState({
		  modal1: !this.state.modal1
		});
	}
	onChangeRemark(e){
		this.setState({remarks : e.target.value});
	}
	onMarkChange(e){
		this.setState({mark : e.target.value});
	}
	onSubChange(e){
		this.state.subject = e.target.value;
		$(".checkmaxval").val('');
		this.getmark();
		this.getmaxmark();
	}
	onExamChange(e){
		this.state.examname = e.target.value;
	}

	onClassChange(e){
		this.state.cls = e.target.value;
		this.getsection();
	}
	
	/** set value **/
	onChange(e){
		//this.setState({[e.target.name]:e.target.value});
		this.state.acyear = e.target.value;
		this.getexam();
	}
	
	/** set value **/
	onSecChange(e){
		this.state.section = e.target.value;
		this.getdata();
		this.getsubject();
	}
	
	handleChange(id,e){
		
		this.state.regno = id;
		this.state.mark = e.target.id;
		this.setState({
		  modal: !this.state.modal
		});
	}
	
	handleRemarkChange(id,e){
		
		this.state.regno = id;
		this.state.remarks = e.target.id;
		this.setState({
		  modal1: !this.state.modal1
		});
	}
	
	onInputChange(id,e){
		
		var index = this.state.marks.findIndex(function(obj){
			
		return (obj.id == id); });
		
		if(index === -1){ 
		
			this.state.marks.push({"id":id, "mark":e.target.value, "remarks":0});
		}
		else{
			
			this.state.marks[index].mark = e.target.value;
	
		}
	}
	
	onRemarkChange(id,e){
		
		var index = this.state.marks.findIndex(function(obj){
		return (obj.id == id); });
		
		if(index != -1){ 
			
			this.state.marks[index].remarks = e.target.value;
			
		}
	}
	
	onClick(e){
		
		document.getElementById("examform").reset();
	}
	
	onMarkUpdate(e){
		e.preventDefault();
		 $("#showLoader").show();
		 
		 var qdata = { acyear: this.state.acyear, cls : this.state.cls, section : this.state.section, examname : this.state.examname, subject : this.state.subject, regno : this.state.regno, mark : this.state.mark };
		 
		PostData('exam/updatemarks', { sdata: qdata }).then((result) => {
			 $("#showLoader").hide();
			let responseJson = result;
			if(responseJson.status == '1' ){
				this.toggle();
				this.getmark();
			}
			else{
				this.toggle();
				this.getmark();
			}
		});	
	}
	
	onReMarkUpdate(e){
		e.preventDefault();
		 $("#showLoader").show();
		PostData('exam/updateremarks',this.state).then((result) => {
			 $("#showLoader").hide();
			let responseJson = result;
			if(responseJson.status == '1' ){
				this.toggle1();
				this.getmark();
			}
			else{
				this.toggle1();
				this.getmark();
			}
		});	
	}
	
	onSubmit(e){
		e.preventDefault();
		 $("#showLoader").show();
		this.state.maxmark = $("#mmark").val();
		PostData('exam/saveexammarks',this.state).then((result) => {
			 $("#showLoader").hide();
			let responseJson = result;
			if(responseJson.status == '1' ){
				$(".checkmaxval").val('');
				this.state.marks = [];
				alert('Marks Added Successfully!..');
				this.getmark();
				this.getdata();
			}
			else{
		
				this.setState({
					_message:'Invalid Key',
					alertClass:'alert alert-danger'
				});
			}
		});	
	}
	
	onUpdate(){
		 $("#showLoader").show();
		PostData('exam/editpassmark',this.state).then((result) => {
			 $("#showLoader").hide();
			let responseJson = result;
			if(responseJson.status == '1' ){
				this.toggle();
				this.setState({
					_message:'Time Table Updated Successfully!..',
					alertClass:'alert alert-success',
				});
				//this.setState({subject : '',passmark : ''});
				this.getdata();
			}
			else{
				this.toggle();
				this.setState({
					_message:'Invalid Key',
					alertClass:'alert alert-danger'
				});
			}
		});	
		
	}
	
	componentWillMount() {
		 
		this.getacyear();
		this.getclass();
	}
	
		/** get Academic Year **/
	getacyear(){
		 $("#showLoader").show();
		GetData('academic/getacyear').then((result) => {
			 $("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					accyear : responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
				
				let userData = JSON.parse(sessionStorage.getItem('userData'));
				this.state.userId = userData['userid'];
				this.state.userRole = userData['userrole'];
				this.state.staffid = userData['staffid'];
				this.setState({
					staffid: userData['staffid']
				});
				if(userData['userrole'] == 'markentry'){
					this.checkstaff();
				}
				if(userData['userrole'] == 'classteacher'){
					this.checkclassteacher();
				}
				this.getallocatesection();
				this.getexam();
			}
		});
	}
	
	checkstaff(){
		$("#showLoader").show();
		GetData('employee/checkstaff/'+this.state.acyear+'/'+this.state.staffid).then((result) => {
			let responseJson = result;
			if(responseJson.status==1){
				this.setState({
					allocateSubject : responseJson.data,
					allocateClass : responseJson.class,
				});
			}
			$("#showLoader").hide();
		});
	}

	checkclassteacher(){
		$("#showLoader").show();
		GetData('employee/checkclassteacher/'+this.state.acyear+'/'+this.state.staffid).then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					allocateClass : responseJson
				});
			}
			$("#showLoader").hide();
		});
	}

	//get allocate section details
	getallocatesection(){

		GetData('section/getsecbyacyear/'+this.state.acyear).then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					sections : responseJson
				});
			}
		});
	}
	
	getclass(){
		 $("#showLoader").show();
		GetData('classs/getclass').then((result) => {
			 $("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}

	// Get Section By Class
	getsection(){
		var dat = [];
		if(this.state.cls!=''){
			for(var i=0;i<this.state.sections.length;i++)	{

				if(this.state.sections[i].clas == this.state.cls){
					dat.push(this.state.sections[i]);
				}
			}
		}
		this.setState({sec : dat});
	}
	
	getexam(){
		
		var ac = $("#year").val();
		 $("#showLoader").show();
		GetData('exam/getexambyacyear/'+this.state.acyear).then((result) => {
			 $("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					exams : responseJson
				});
			}
		});
	}
	
	getsubject(){
		
		 $("#showLoader").show();
		GetData('assignsubject/getsubbyclsdim/'+this.state.acyear+'/'+this.state.cls).then((result) => {
			 $("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					subj : responseJson
				});
			}
		});
	}
	
	getdata(){
		
		$("#showLoader").show();
		GetData('student/getstddetailsbymsg/'+this.state.acyear+'/'+this.state.cls+'/'+this.state.section).then((result) => {
			 $("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					data : responseJson
				});
			}
		});
	}
	
	getmaxmark(){
		$("#showLoader").show();
		$.get(GLOBAL.BASE_URL+'exam/getmaxmark/'+this.state.acyear+'/'+this.state.cls+'/'+this.state.examname+'/'+this.state.subject,function(o){
			 $("#showLoader").hide();
			$("#maxmark").html('');
			$.each(o,function(key,value){			
				   $('#maxmark').html(value.maxmark);
				   $('#mmark').val(value.maxmark);
			});	
			
		},'json');
	}

	getmark(){
		
		 $("#showLoader").show();
		GetData('exam/getmarks/'+this.state.acyear+'/'+this.state.cls+'/'+this.state.section+'/'+this.state.examname+'/'+this.state.subject).then((result) => {
			 $("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					markdata : responseJson
				});
			}
		});
	}
	
	getmarkbystud(regno){
		
		var dat = [];
		
		if(this.checkmarks(regno)!=false){
			
			dat.push(<td><Button size="sm" color={this.checkmarks(regno) == 'AB' ? "danger" : "primary"} id={this.checkmarks(regno)} onClick={this.handleChange.bind(this,regno)}>{this.checkmarks(regno)}</Button></td>);
		}
		else{
			
			dat.push(<td>
				<input type="text" list="absent" className="checkmaxval" onKeyPress={Sanitize.integerKeyPress} onChange={this.onInputChange.bind(this,regno)} />
				<datalist id="absent">
					<option value="AB"></option>
				</datalist>
			</td>);
		}
		
		return dat;
	}
	
	checkmarks(regno){
		
		var bstate = false;
		
		for(var i=0; i<this.state.markdata.length; i++){
			
			if(this.state.markdata[i].studentid == regno){
				
				bstate = parseFloat(this.state.markdata[i].mark) == '-1' ? 'AB' : parseFloat(this.state.markdata[i].mark);
				break;
			}
			else{
				
				bstate = false;
			}
		}
		
		return bstate;
	}
	
	getremark(regno){
		
		var dat1 = [];
		
		if(this.checkremarks(regno)=== false){
			
			dat1.push(<td><input type="text" onChange={this.onRemarkChange.bind(this,regno)} /></td>);
		}
		else{
			
			dat1.push(<td><Button size="sm" color="primary" onClick={this.handleRemarkChange.bind(this,regno)}>{this.checkremarks(regno)}</Button></td>);
			
		}
		
		return dat1;
	}
	
	checkremarks(regno){
		
		var boolstate = false;
		
		for(var j=0; j<this.state.markdata.length; j++){
			
			if(this.state.markdata[j].studentid == regno){
				
				boolstate = this.state.markdata[j].remarks;
				break;
			}
			else{
				
				boolstate = false;
			}
		}
		
		return boolstate;
	}
	
	checkSub(sub){
		var bstate = false;
		var d = this.state.allocateSubject;
		var index = d.findIndex(function(obj){
			return(obj.subject == sub);
		});
		if(index > -1){
			bstate = true;
		}
		return bstate;
	}
	
	checkClass(cls){
		var bstate = false;
		var d = this.state.allocateClass;
		if(this.state.userRole == 'classteacher'){
			var index = d.findIndex(function(obj){
				return(obj.class == cls);
			});
			if(index > -1){
				bstate = true;
			}
		}
		else if(this.state.userRole == 'markentry'){
			if(d.length > 0){
				var dat = d[0]['classes'].split(',');
				var index = dat.findIndex(function(obj){
					return(obj == cls);
				});
				if(index > -1){
					bstate = true;
				}
			}
		}
		return bstate;
	}
	
	checkSection(sec){
		var bstate = false;
		var d = this.state.allocateClass;
		var index = d.findIndex(function(obj){
			return(obj.section == sec);
		});
		if(index > -1){
			bstate = true;
		}
		return bstate;
	}
	
  render() {
	  
	if(this.state._redirect){
		  
		return (<Redirect to={'/subject/subjectupdate/' + this.state.idd} />);

	}
	
	var exa = this.state.exams;
	var items = this.state.posts;
	var acyear = this.state.accyear;
	var sub = this.state.subj;
	var secs = this.state.sec;
	
	if(this.state.acyear!='' && this.state.cls!='' && this.state.section!='' && this.state.subject!='' && this.state.examname!=''){
		
		$("#markenter").show();
	}
	else{
		
		$("#markenter").hide();
	}
	this.state.mval = $("#mmark").val();
	
	let userData = JSON.parse(sessionStorage.getItem('userData'));
    this.state.userId = userData['userid'];
    this.state.userRole = userData['userrole'];
	this.state.staffid = userData['staffid'];

    return (
		<div>
		  <AcademicPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
			  <form action="" method="post" role="form" id="markform" encType="multipart/form-data" onSubmit={this.onSubmit} >
			  <input type="hidden" name="maxmark" id="mmark" />
				<Row>
				  <Col md="12">
					<Card>
						<CardHeader>
							<strong>Enter Marks by Subject</strong>
							<span style={{float : 'right'}}>Total Marks : <span id="maxmark"></span></span>
							<Row style={{margintop : '10px'}}>
								<Col md={2} sm={12} xs={12}>
									<label>Academic Year</label>
									<select name="acyear" onChange={this.onChange} className="form-control" required id="year">
										<option value="">Select Academic Year</option>
										{
											acyear.map(function (item) {
												return <option value={item.id }>{item.value}</option>;
											})
										}
									</select>
								</Col>
								<Col md={2} sm={12} xs={12}>
									<label>Class</label>
									<select name="cls" onChange={this.onClassChange} className="form-control" required id="clas">
										<option value="">Select Class</option>
										{(this.state.userRole == 'classteacher' || this.state.userRole == 'markentry') ?
											items.map((item)=>{
												if(this.checkClass(item.id)){
													return <option value={item.id}>{item.class}</option>;
												}
											})
											:
											items.map(function (item) {
												return <option value={item.id}>{item.class}</option>;
											})
										}
									</select>
								</Col>
								<Col md={2} sm={12} xs={12}>
									<label>Section</label>
									<select name="section" onChange={this.onSecChange} className="form-control" required id="secs">
										<option value="">Select Section</option>
										{(this.state.userRole == 'classteacher') ?
											secs.map((item)=>{
												if(this.checkSection(item.section)){
													return <option value={item.section}>{item.secs}</option>;
												}
											})
											:
											secs.map(function (item) {
												return <option value={item.section}>{item.secs}</option>;
											})
										}
									</select>
								</Col>
								<Col md={3} sm={12} xs={12}>
									<label>Exam</label>
									<select name="examname" onChange={this.onExamChange} className="form-control" required id="exam">
										<option value="">Select Exam</option>
										{
											exa.map(function (item) {
												return <option value={item.id }>{item.exam}</option>;
											})
										}
									</select>
								</Col>
								<Col md={3} sm={12} xs={12}>
									<label>Subject</label>
									<select name="subject" onChange={this.onSubChange} className="form-control" required id="sub">
										<option value="">Select Subject</option>
										{(this.state.userRole == 'markentry') ?
											sub.map((item)=>{
												if(this.checkSub(item.subject)){
													return <option value={item.subject}>{item.sub}</option>;
												}
											})
											:
											sub.map(function (item) {
												return <option value={item.subject}>{item.sub}</option>;
											})
										}
									</select>
								</Col>
							</Row>
						</CardHeader>
						<CardBody>
							<Row id="markenter">
							  <Col md="12">
								<Table responsive bordered>
									<thead>
										<tr>
											<th>S.No</th>
											<th>Reg No</th>
											<th>Student Name</th>
											<th>Mark</th>
											<th>Remarks</th>
										</tr>
									</thead>
									<tbody>
										{this.state.data.map((item,index) =>
							 
											<tr key = {item}>
												<td>{index+1}</td>
												<td>{item.regno}</td>
												<td>{item.stdname}</td>
												{this.getmarkbystud(item.regno)}
												{this.getremark(item.regno)}
											</tr>
										)}
									</tbody>
								</Table>
								<Modal isOpen={this.state.modal} toggle={this.toggle} className={'modal-sm ' + this.props.className}>
								  <ModalHeader toggle={this.toggle}>Edit Mark</ModalHeader>
								  <ModalBody>
									<Row>
									  <Col md="12">
									   <FormGroup>
										<Label htmlFor="name">Mark <span className="text-danger">*</span></Label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
											<input type="text" name="mark" list="absent" onKeyPress={Sanitize.integerKeyPress} required value={this.state.mark} onChange={this.onMarkChange} />
											<datalist id="absent">
												<option value="AB"></option>
											</datalist>
									   </FormGroup>
									  </Col>
									</Row>
								  </ModalBody>
								  <ModalFooter>
									<Button type="submit" color="primary" onClick={this.onMarkUpdate}>Submit</Button>
									<Button color="secondary" onClick={this.toggle}>Cancel</Button>
								  </ModalFooter>
							  </Modal>
							  <Modal isOpen={this.state.modal1} toggle={this.toggle1} className={'modal-sm ' + this.props.className}>
								  <ModalHeader toggle={this.toggle1}>Edit Remarks</ModalHeader>
								  <ModalBody>
									<Row>
									  <Col md="12">
									   <FormGroup>
										<Label htmlFor="name">remark <span className="text-danger">*</span></Label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
										<input type="text" name="remarks" value={this.state.remarks} onChange={this.onChangeRemark} />
									   </FormGroup>
									  </Col>
									</Row>
								  </ModalBody>
								  <ModalFooter>
									<Button type="submit" color="primary" onClick={this.onReMarkUpdate}>Submit</Button>
									<Button color="secondary" onClick={this.toggle1}>Cancel</Button>
								  </ModalFooter>
							  </Modal>
							  </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" className="btn-right" color="primary"><i className="fa fa-dot-circle-o"></i> Save</Button>
						</CardFooter>
					</Card>
				  </Col>
				</Row>
			  </form>
			</div>
		</div>
	)
  }
}

export default EnterMark;


// WEBPACK FOOTER //
// ./src/exams/Mark/EnterMark.js